import React from 'react';
import FactoryOutlinedIcon from '@mui/icons-material/FactoryOutlined';
import {
    SlideContainer, SlideTitle, SlideSubtitle, SlideText, BulletList, BulletItem, IconCircle,
    welcomeSlide, historicSlide, finalSlide,
} from 'components/v3/onboarding/OnboardingSlideElements';

// ==========================================
// Profil PARTNER — partner
// Atterrissage : /partner. Voit Industriel + Organisation + Intégration.
// ==========================================

export const partnerSlides = () => [
    welcomeSlide(
        "Votre espace s'articule autour de la page « Industriel », complétée par l'historique de vos scans et par vos paramètres.",
    ),

    {
        title: '1 · Industriel',
        content: (
            <SlideContainer>
                <SlideTitle>
                    <IconCircle><FactoryOutlinedIcon /></IconCircle>
                    1 · Industriel
                </SlideTitle>
                <SlideText>
                    Votre page d'accueil : le suivi des emballages que vous produisez et mettez en circulation.
                </SlideText>
                <SlideText>
                    Vous y retrouvez les volumes concernés et l'état du parc, sur le périmètre qui vous est ouvert.
                </SlideText>

                <SlideSubtitle>Vos paramètres</SlideSubtitle>
                <BulletList>
                    <BulletItem>
                        <strong>Organisation</strong> et <strong>Membres</strong> — les informations de votre structure
                        et qui y a accès.
                    </BulletItem>
                    <BulletItem>
                        <strong>Mes lieux</strong> et <strong>Mes flux</strong> — vos sites, et les trajets types entre eux.
                    </BulletItem>
                    <BulletItem>
                        <strong>Config MOBIUScan</strong> et <strong>Intégration</strong> — les appareils de scan et les
                        connexions à vos propres outils.
                    </BulletItem>
                    <BulletItem>
                        <strong>Catégorisation des anomalies</strong> — vos catégories de dégâts, reprises dans les
                        écrans terrain.
                    </BulletItem>
                    <BulletItem>
                        <strong>Mon compte</strong> — vos informations personnelles.
                    </BulletItem>
                </BulletList>
            </SlideContainer>
        ),
    },

    historicSlide(2),
    finalSlide(),
];
